import { useEffect, useState } from "react";
import styles from "./Popup.module.css";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { Button, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select } from "@mui/material";
import { Close } from "@mui/icons-material";
import { authData } from "../GetAuth";
import { Check, X } from "react-feather";

export default function AssignPopup({ setLoading, modalClose, bookingIds, onSubmit, setFormOpen }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [driverList, setDriverList] = useState([]);

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/p-driver-dd-list", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setDriverList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const onSubmitLocal = (data) => {
    modalClose(false);
    setLoading(true);

    data = { ...data, bookingIds: bookingIds };

    axios.post(process.env.REACT_APP_API_URL + "v1/assign-bookings", data, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setLoading(false);
        onSubmit();
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  };

  return (<>
    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className={`${styles.PopupTitleBar}`}>
      Assign Booking Details To Driver
      <IconButton aria-label="close" onClick={(e) => setFormOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupFull}`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select Driver*</InputLabel>
              <Controller
                control={control}
                {...register("driver_id", { required: "Please select driver" })}
                render={({ field }) => (
                  <Select {...field} label="Select Driver*">
                    {driverList?.map((i) => {
                      return (<MenuItem key={i?.id} value={i?.id}>{i?.name}</MenuItem>);
                    })}
                  </Select>
                )}
              />
            </FormControl>
            {errors.driver_id && (<span className={`${styles.ErrorM}`}>{errors?.driver_id?.message}</span>)}
          </div>
        </div>
        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => modalClose(false)}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">Assign</Button>
        </div>
      </form>
    </DialogContent>
  </>);
}